module.exports = __webpack_public_path__ + "img/exclusive-experiences.b19fe816.svg";